import { Plans } from '../pages/constants';
import { simpleFetch } from './customFetch';

/** Sentinel UUID ace-api expects for catalog/sale on a subscription cart item. */
export const ZERO_UUID = '00000000-0000-0000-0000-000000000000';

type UncurlPartialRollout = {
  shopUserId?: number;
  userUuid?: string;
  partialRolloutFlag?: boolean;
};

// Hand-rolled raw fetch rather than user-sdk's getUncurlPartialRollout: this legacy Redux app has no
// SDK wiring and uses raw `customFetch` throughout (Option 1 for FP-1416). The path mirrors the SDK.
//
// Cache the flag fetch for the session — the upgrade pages may re-render, and the rollout value is
// stable per user. A failed fetch resolves to undefined (see customFetch); resolveIsCartPath treats
// that as false, so we fail safe to the legacy plan-code path.
let rolloutPromise: Promise<UncurlPartialRollout | undefined> | null = null;

export const getUncurlPartialRollout = (): Promise<UncurlPartialRollout | undefined> => {
  if (!rolloutPromise) {
    rolloutPromise = simpleFetch(
      '/api/v3/users/uncurl-partial-rollout/self',
      { method: 'GET' },
      process.env.REACT_APP_USER_API,
    );
  }
  return rolloutPromise;
};

// Resolve the UnCurl / Cart 2.0 gate before choosing a path. An unresolved or failed flag fails
// safe to the legacy plan-code path, which is correct for the not-yet-flagged majority.
export const resolveIsCartPath = async (): Promise<boolean> => {
  try {
    const rollout = await getUncurlPartialRollout();
    return rollout?.partialRolloutFlag === true;
  } catch {
    return false;
  }
};

// Strict plan-code → ace-api GLAM subscription product UUID map used to build the INSTANT upgrade
// cart. Only the annual/seasonal box plans resolve; anything else (trial, club, no subscription,
// unknown) returns '' so the caller sends `current_product_uuid: null` rather than an invalid one.
// UUIDs are env-specific and read from `REACT_APP_*`.
export const getSubscriptionProductUuid = (planCode?: string): string => {
  if (planCode === Plans.ANNUAL) {
    return process.env.REACT_APP_ANNUAL_SUBSCRIPTION_PRODUCT_UUID ?? '';
  }
  if (planCode === Plans.SEASONAL) {
    return process.env.REACT_APP_SEASONAL_SUBSCRIPTION_PRODUCT_UUID ?? '';
  }
  return '';
};

// Reset the cached rollout fetch. Test-only.
export const __resetUncurlCache = () => {
  rolloutPromise = null;
};
